import React from 'react';
import { Box, Flex, Input } from '@chakra-ui/react';
import { SearchIcon } from '../../../../utils/icons/search';
import { t } from 'i18next';

export const Lookup = ({ value, handleChange }: { value: string; handleChange: (content: string) => void }) => {
	const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;

		handleChange(value);
	};

	return (
		<Flex position="relative">
			<Input
				placeholder={t('library.filter.lookup').toString()}
				fontSize="inherit"
				borderRadius="4px"
				borderColor="#FFFFFF40"
				padding="16px 30px"
				background="#12121280"
				value={value.toString()}
				_placeholder={{ color: 'white', opacity: '.5' }}
				onChange={handleInputChange}
			/>
			<Box
				position="absolute"
				top="50%"
				left="15px"
				transform="translate(-25%, -55%)"
				pointerEvents="none"
			>
				<SearchIcon size="1em" />
			</Box>
		</Flex>
	);
};
